import angular from 'angular';

angular
  .module('cloudX')
  .controller('ProfileCtrl', [
    'resourceFactorySvc',
    'dataCache',
    'flySvc',
    'ModalService',
    'dialogsSvc',
    'appUrls',
    '$window',
    'checkSecurity',
    'checkTenantConfiguration',
    '$http',
    profileCtrl,
  ]);

function profileCtrl(
  resourceFactorySvc,
  dataCache,
  flySvc,
  ModalService,
  dialogsSvc,
  appUrls,
  $window,
  checkSecurity,
  checkTenantConfiguration,
  $http,
) {
  var vm = this;
  vm.usesSSO = checkTenantConfiguration('sso');
  vm.employee = dataCache.getArray('employee');
  vm.connectWebUrl = `${appUrls.connect}`;
  vm.isRealUser = !checkSecurity('Support');
  dataCache.ready().then(function() {
    const companyId = dataCache.getArray('defaultcompany').id;
    vm.connectWebUrl = `${appUrls.connect}?companyId=${companyId}`;
  });

  vm.openConnect = function() {
    $window.open(vm.connectWebUrl, '_blank');
  };

  var resource = resourceFactorySvc.get('employee');

  if (vm.isRealUser) {
    $http.get(`${appUrls.api}/api/employee/profile`).then(function({ data }) {
      vm.profile = data;
    });
  } else {
    vm.profile = vm.employee;
  }

  vm.submit = function(value, field) {
    if (!vm.isRealUser) return false;
    if (vm.profile[field] === value) return false;

    var model = angular.copy(vm.profile);
    model[field] = value;
    return resource.updateMyProfile(model).$promise.then(
      function(result) {
        if (result) {
          vm.profile = result;
          dataCache.update('employee', result);
        }
        flySvc.success('msgConfirmChange');
        return false;
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
        return '';
      },
    );
  };

  vm.changePassword = function() {
    if (!vm.isRealUser) return;
    ModalService.showModal({
      template: require('./dialogs/changePasswordDialog.html'),
      controller: 'ChangePasswordDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
    });
  };

  vm.changeUsername = function() {
    if (!vm.isRealUser) return;
    ModalService.showModal({
      template: require('./dialogs/changeUsernameDialog.html'),
      controller: 'ChangeUsernameDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
    });
  };

  vm.refreshEmployee = function() {
    resource.getProfile({}, function(profile) {
      vm.profile = profile;
      vm.employee = profile;
    });
  };

  vm.enable2Fa = function() {
    if (!vm.isRealUser) return;
    ModalService.showModal({
      template: require('./dialogs/enable2FADialog.html'),
      controller: 'Enable2FADialog',
      controllerAs: 'vm',
      locationChangeSuccess: false,
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
        vm.refreshEmployee();
      });
    });
  };

  vm.disable2Fa = function() {
    if (!vm.isRealUser) return;
    ModalService.showModal({
      template: require('./dialogs/disable2FADialog.html'),
      controller: 'Disable2FADialog',
      controllerAs: 'vm',
      locationChangeSuccess: false,
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
        vm.refreshEmployee();
      });
    });
  };
  vm.translateEmailRemark = function() {
    if (!vm.profile?.userId) return;
    dialogsSvc
      .translateListItem('useremailremark', vm.profile.userId, '', {
        inputRows: 7,
        defaultRequired: false,
        maxlength: 500,
      })
      .then(function(result) {
        if (result) {
          //This is a special case for the translations.
          //If we use the default as fallback, you can't leave another language empty.
          flySvc.success();
        }
      });
  };
}
